// Mock data for CYA Youth Academy

export const brand = {
  name: "CYA Youth Academy",
  short: "CYA",
  location: "Vizianagaram",
  tagline: "Learn Today • Lead Tomorrow • Shape Your Future",
  motto: "Invest in Yourself!",
  phone: "+91 82496 22167",
  phoneDial: "tel:+918249622167",
  whatsapp: "https://wa.me/918249622167",
  email: "info@cyayouthacademy.in",
  address: "Near Winway School, VT Agraharam, Vizianagaram, Andhra Pradesh 535004, India",
  addressShort: "VT Agraharam, Vizianagaram, AP 535004",
  city: "Vizianagaram",
  state: "Andhra Pradesh",
  pincode: "535004",
  country: "India",
  mapEmbed:
    "https://www.google.com/maps?q=CYA+Youth+Academy,+VT+Agraharam,+Vizianagaram,+Andhra+Pradesh+535004&hl=en&z=16&output=embed",
  mapDirections:
    "https://www.google.com/maps/place/CYA+Youth+Academy/data=!4m2!3m1!1s0x0:0xe8b9290b6f02551d",
  mapShare: "https://share.google/nGmYvkBL69Aav9qIL",
  hours: [
    { day: "Monday", time: "9 AM – 5 PM" },
    { day: "Tuesday", time: "9 AM – 5 PM" },
    { day: "Wednesday", time: "9 AM – 5 PM" },
    { day: "Thursday", time: "9 AM – 5 PM" },
    { day: "Friday", time: "9 AM – 5 PM" },
    { day: "Saturday", time: "Open 24 hours" },
    { day: "Sunday", time: "Open 24 hours" },
  ],
  chip: ["DREAM", "LEARN", "ACHIEVE"],
};

export const usps = [
  { title: "Expert Trainers", desc: "Industry-experienced mentors guiding every learner.", icon: "UserRound" },
  { title: "Practical Learning", desc: "Hands-on sessions, projects and real performance.", icon: "Medal" },
  { title: "Career Focused", desc: "Skills that create real opportunities and income.", icon: "TrendingUp" },
  { title: "Youth Empowerment", desc: "Confidence, culture and community – all in one.", icon: "Users" },
];

export const courses = [
  {
    id: "guitar",
    title: "Guitar",
    subtitle: "Learn to play. Express yourself. Feel the music.",
    duration: "3 Months",
    level: "Beginner → Advanced",
    color: "from-amber-400 to-orange-500",
    accent: "#fbbf24",
    image: "https://images.pexels.com/photos/35257328/pexels-photo-35257328.jpeg",
    highlights: ["Acoustic & Electric", "Chords & Strumming", "Live Performance"],
  },
  {
    id: "spoken-english",
    title: "Spoken English",
    subtitle: "Speak confidently. Communicate effectively. Succeed globally.",
    duration: "2 Months",
    level: "All Levels",
    color: "from-sky-400 to-blue-600",
    accent: "#38bdf8",
    image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4",
    highlights: ["Fluency Drills", "Group Discussions", "Interview Prep"],
  },
  {
    id: "english-rw",
    title: "English – Reading & Writing",
    subtitle: "Improve grammar. Enhance writing. Build strong communication.",
    duration: "2 Months",
    level: "School / College",
    color: "from-indigo-400 to-indigo-700",
    accent: "#818cf8",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173",
    highlights: ["Grammar Mastery", "Essay Writing", "Comprehension"],
  },
  {
    id: "korean",
    title: "Korean Language (한국어)",
    subtitle: "Learn Korean. Explore culture. Open new opportunities.",
    duration: "3 Months",
    level: "TOPIK I aligned",
    color: "from-pink-400 to-rose-500",
    accent: "#f472b6",
    image: "https://images.pexels.com/photos/15121561/pexels-photo-15121561.jpeg",
    highlights: ["Hangul Basics", "K-Culture Sessions", "Career in Korea"],
  },
  {
    id: "editing",
    title: "Computer Editing",
    subtitle: "Edit. Create. Inspire. Bring stories to life.",
    duration: "2 Months",
    level: "Beginner Friendly",
    color: "from-cyan-400 to-teal-500",
    accent: "#22d3ee",
    image: "https://images.pexels.com/photos/11553189/pexels-photo-11553189.jpeg",
    highlights: ["Premiere Pro", "After Effects Basics", "Reels & Shorts"],
  },
  {
    id: "piano",
    title: "Piano",
    subtitle: "Learn keys. Play melodies. Create harmony.",
    duration: "3 Months",
    level: "All Ages",
    color: "from-lime-400 to-green-600",
    accent: "#a3e635",
    image: "https://images.unsplash.com/photo-1512733596533-7b00ccf8ebaf",
    highlights: ["Music Theory", "Classical & Pop", "Recital Ready"],
  },
  {
    id: "smm",
    title: "Social Media Marketing",
    subtitle: "Build brand. Grow audience. Create impact. Go digital.",
    duration: "2 Months",
    level: "Career Track",
    color: "from-fuchsia-400 to-pink-600",
    accent: "#e879f9",
    image: "https://images.pexels.com/photos/7873559/pexels-photo-7873559.jpeg",
    highlights: ["Instagram Growth", "Meta Ads", "Content Strategy"],
  },
];

export const testimonials = [
  {
    name: "Priya Sri",
    course: "Spoken English",
    quote: "I couldn't speak a full English sentence before. Now I lead college presentations!",
    rating: 5,
  },
  {
    name: "Rohit Varma",
    course: "Guitar",
    quote: "From zero to my first stage performance in 10 weeks. The trainers are amazing.",
    rating: 5,
  },
  {
    name: "Anjali K.",
    course: "Korean Language",
    quote: "Loved the cultural sessions. Cleared TOPIK I with confidence.",
    rating: 5,
  },
  {
    name: "Suresh Naidu",
    course: "Social Media Marketing",
    quote: "Started freelancing for local businesses within a month of joining. Real skills!",
    rating: 5,
  },
];

export const stats = [
  { value: "1500+", label: "Students Trained" },
  { value: "7", label: "Signature Courses" },
  { value: "25+", label: "Expert Trainers" },
  { value: "4.9★", label: "Learner Rating" },
];

export const faqs = [
  {
    q: "Where is CYA Youth Academy located?",
    a: "We are located in Vizianagaram, Andhra Pradesh. Walk-ins welcome between 9 AM – 8 PM.",
  },
  {
    q: "Do you provide certificates after completion?",
    a: "Yes. Every learner receives an academy certificate on successful completion of assessments.",
  },
  {
    q: "Are the classes online or offline?",
    a: "Both. Choose in-centre batches or live online sessions – whichever fits your schedule.",
  },
  {
    q: "What is the age group you accept?",
    a: "We welcome learners from age 8 to working professionals. Batches are grouped by level.",
  },
  {
    q: "How do I enrol?",
    a: "Fill the enquiry form on this page or call 82496 22167. Our counsellor will schedule a free demo.",
  },
];

export const heroImages = {
  primary: "https://images.unsplash.com/photo-1593697972672-b1c1902219e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMG11c2ljaWFufGVufDB8fHx8MTc4NDc2MTU5NHww&ixlib=rb-4.1.0&q=85",
  secondary: "https://images.pexels.com/photos/6958553/pexels-photo-6958553.jpeg",
};

export const studyAbroad = {
  country: "South Korea",
  university: "Gimcheon University",
  universityKr: "김천대학교",
  location: "Gimcheon, Gyeongsangbuk-do, South Korea",
  tagline: "Shape your future with a global education",
  subhead: "Your gateway to a bright global career",
  hero: "https://images.unsplash.com/photo-1493589976221-c2357c31ad77",
  campus: "https://images.unsplash.com/photo-1777731476530-bd4e64645d16",
  culture: "https://images.unsplash.com/photo-1724322727370-da4b1fcd8fc0",
  pillars: [
    { title: "Quality Education", desc: "Reputed private university with modern facilities.", icon: "GraduationCap" },
    { title: "Global Career Opportunities", desc: "Pathways to internships and jobs across Asia.", icon: "Globe" },
    { title: "International Student Support", desc: "Dedicated help with visa, housing and mentors.", icon: "Users" },
    { title: "Bright Future Starts Here", desc: "Scholarships available on merit and eligibility.", icon: "Lightbulb" },
  ],
  programs: [
    {
      name: "Humanities & Social Sciences",
      color: "#7C3AED",
      items: ["Korean Language & Literature", "English Language & Literature", "Social Welfare", "Counseling Psychology", "Police Administration"],
    },
    {
      name: "Business & Economics",
      color: "#0EA5A4",
      items: ["Business Administration", "Accounting & Taxation", "Hotel & Tourism Management", "Global Trade"],
    },
    {
      name: "Health & Medical Sciences",
      color: "#E11D48",
      items: ["Nursing", "Physical Therapy", "Radiologic Science", "Optometry", "Dental Hygiene", "Health Administration"],
    },
    {
      name: "Science & Engineering",
      color: "#2563EB",
      items: ["Computer Engineering", "Information & Communication", "Smart Mobility", "Energy & Environmental Engineering"],
    },
    {
      name: "Arts & Sports",
      color: "#DB2777",
      items: ["Visual & Media Arts", "Music", "Performing Arts", "Taekwondo", "Sports & Leisure"],
    },
    {
      name: "Natural Sciences",
      color: "#16A34A",
      items: ["Food & Biotechnology", "Cosmeceutical Science", "Bioengineering", "Environmental Science"],
    },
  ],
  whyChoose: [
    "Recognized and reputed private university in South Korea",
    "Wide range of undergraduate and graduate programs",
    "Strong support for international students",
    "Affordable tuition fees compared to other Korean universities",
    "Modern campus with excellent facilities",
    "Safe, peaceful and student-friendly city",
  ],
  notices: [
    "Admission is open for international students.",
    "Early application is highly recommended as seats are limited.",
    "Korean language proficiency (TOPIK) may be required for some programs.",
    "Scholarship opportunities available based on performance and eligibility.",
    "For detailed eligibility, application process and latest updates, please contact the authorized admission partner.",
  ],
  cta: {
    heading: "Take the Next Step Towards Your Dream!",
    subheading: "Your future. Your choice. Gimcheon University – Where dreams take flight!",
  },
};
